/**
 * External dependencies
 */
import { useEffect, useState } from '@wordpress/element';
import { registerPaymentMethod } from '@woocommerce/blocks-registry';
import { __ } from '@wordpress/i18n';
import { getSetting } from '@woocommerce/settings';
import { decodeEntities } from '@wordpress/html-entities';
import { dispatch } from '@wordpress/data';

const settings = getSetting('grow-wallet-payment_data', {});
const defaultLabel = __('Grow Wallet', 'meshulam-payment-gateway');

const label = decodeEntities(settings.title) || defaultLabel;
const { CHECKOUT_STORE_KEY } = window.wc.wcBlocksData;
let currentOrderId = '';

const Content = (props) => {
    const { eventRegistration, emitResponse } = props;
    const { onCheckoutSuccess, onPaymentSetup } = eventRegistration;

    useEffect(() => {

        const processing = onPaymentSetup(async () => {
            const meshulam_pay_exp_type = $(".wc-block-checkout__form [name='meshulam_pay_exp_type']").val();
            const meshulam_pay_exp_numpayment = $(".wc-block-checkout__form [name='meshulam_pay_exp_numpayment']").val();
            const meshulam_pay_exp_numpayment_debit = $(".wc-block-checkout__form [name='meshulam_pay_exp_numpayment_debit']").val();

            if (meshulam_pay_exp_type || meshulam_pay_exp_numpayment || meshulam_pay_exp_numpayment_debit) {
                return {
                    type: emitResponse.responseTypes.SUCCESS,
                    meta: {
                        paymentMethodData: {
                            meshulam_pay_exp_type,
                            meshulam_pay_exp_numpayment,
                            meshulam_pay_exp_numpayment_debit
                        },
                    },
                };
            }
        });

        const unsubscribe = onCheckoutSuccess(async (data) => {

            if (!currentOrderId) {
                console.error("Order ID is missing");
                return;
            }

            try {
                const response = await fetch(settings.ajax_url, {
                    method: 'POST',
                    headers: { 'Content-Type': 'application/x-www-form-urlencoded' },
                    body: new URLSearchParams({
                        order_id: currentOrderId,
                        action: "meshulam_grow_wallet_iframe"
                    })
                });

                const result = await response.json();

                if( result === false ){
                    return { type: emitResponse.responseTypes.SUCCESS };
                } else if (!result || result === 'false') {
                    dispatch('core/notices').createErrorNotice(
                        __('There was an error processing your payment. Please try again.', 'meshulam-payment-gateway'),
                        { context: 'wc/checkout' }
                    );

                    return { type: emitResponse.responseTypes.ERROR };
                }

                if (result.error) {
                    dispatch('core/notices').createErrorNotice(
                        result.error,
                        { context: 'wc/checkout' }
                    );
                    return { type: emitResponse.responseTypes.ERROR };
                }

                growPayment.renderPaymentOptions(result.token);
                redirect = result.thank_you_url;
                order_id = currentOrderId;

            } catch (error) {
                console.error("Error:", error);
                dispatch('core/notices').createErrorNotice(
                    __('An unexpected error occurred. Please try again.', 'meshulam-payment-gateway'),
                    { context: 'wc/checkout' }
                );
            }
        });

        return () => {
            processing();
            unsubscribe();
        };
    }, [
        emitResponse.responseTypes.ERROR,
        emitResponse.responseTypes.SUCCESS,
        onPaymentSetup,
        onCheckoutSuccess
    ]);

    // Fetch override to get order ID safely (works better on iPhone)
    useEffect(() => {
        const originalFetch = window.fetch;
        window.fetch = async function (...args) {
            const response = await originalFetch.apply(this, args);
            const url = typeof args[0] === 'string' ? args[0] : (args[0]?.url || '');
            if (url.includes('/wp-json/wc/store/v1/checkout')) {
                try {
                    const clone = response.clone();
                    const data = await clone.json();
                    if (data.order_id) {
                        currentOrderId = data.order_id;
                    }
                } catch (e) { }
            }
            return response;
        };
        return () => {
            window.fetch = originalFetch;
        };
    }, []);

    return (
        <div dangerouslySetInnerHTML={{ __html: settings.payment_fields }}></div>
    );
}

const unblockBlockCheckout = () => {
    if (typeof window.wc === 'undefined' || !window.wc.wcBlocksData) {
        return;
    }
    const checkoutStore = dispatch(CHECKOUT_STORE_KEY);
    if (checkoutStore.__internalSetRedirectUrl) {
        checkoutStore.__internalSetRedirectUrl(null);
    }
    if (checkoutStore.__internalSetIdle) {
        checkoutStore.__internalSetIdle();
    }
    const { PAYMENT_STORE_KEY } = window.wc.wcBlocksData;
    if (PAYMENT_STORE_KEY && dispatch(PAYMENT_STORE_KEY).__internalSetPaymentIdle) {
        dispatch(PAYMENT_STORE_KEY).__internalSetPaymentIdle();
    }
}

window.growWallet = window.growWallet || {};
window.growWallet.unblockBlockCheckout = unblockBlockCheckout;

const Icon = () => {
    return settings.icon ? <div dangerouslySetInnerHTML={{ __html: settings.icon }}></div> : null;
}

const Label = () => {
    return (
        <span className="icon_label">
            <span>{label}</span>
            <Icon />
        </span>
    );
}

const walletPaymentMethod = {
    name: settings.name,
    label: <Label />,
    placeOrderButtonLabel: settings.button_title,
    content: <Content />,
    edit: <Content />,
    canMakePayment: () => true,
    ariaLabel: label,
    supports: {
        features: settings.supports ?? [],
    },
}

registerPaymentMethod(walletPaymentMethod);
